<template>
	<div v-if="loading">
	</div>
	<div v-else>
		<div>
			<vx-card title="Sendcloud instellingen">
				<div class="w-full vx-row">
					<div class="vx-col w-full ">
						<label>
							Door je sendcloud account te koppelen aan Piqwise, kun je via Piqwise labels aanmaken in Sendcloud.<br />
							In onderstaand formulier kun je je Sendcloud API-sleutels invullen. Deze zijn nodig om je Sendcloud account te kunnen
							koppelen aan Piqwise.<br /><b>Let op! Voor het aanmaken van labels worden via Sendcloud kosten in rekening
							gebracht.</b><br /><br />
						</label>
					</div>
					<div class="vx-col w-full">
						<h3>Publieke Sleutel:</h3>
					</div>
					<div class="vx-col w-full ">
						<vs-input v-if="!coupled" v-validate="'required|length:32'" name="publicKey" v-model="submitCredentials.public_key"
								  class="w-full" placeholder="Publieke sleutel" />
						<label v-if="coupled">{{ this.credentials.public_key }}</label>
						<span class="text-danger text-sm" v-show="errors.has('publicKey')">{{ errors.first('publicKey') }}</span>&emsp;
					</div>
					<div class="vx-col w-full">
						<h3>Geheime Sleutel:</h3>
					</div>
					<div class="vx-col w-full">
						<vs-input v-if="!coupled" v-validate="'required|length:32'" v-model="submitCredentials.private_key" class="w-full"
								  name="privateKey" placeholder="Geheime sleutel" />
						<label v-if="coupled">{{ this.credentials.private_key }}</label>
						<span class="text-danger text-sm" v-show="errors.has('privateKey')">{{ errors.first('privateKey') }}</span>&emsp;
					</div>
					<div class="vx-col w-full">
						<vs-button v-if="!coupled" class="btn-submit " color="primary" type="border"
								   @click.native="validateCreate">Koppelen
						</vs-button>
					</div>
				</div>
			</vx-card>
		</div>
		<br />
		<div>
			<vx-card v-if="coupled" title="Sendcloud instellingen">
				<div class="w-full vx-row">
					<div v-if="(this.shippingOptions.length === 0)"
						 class="vx-col w-full">
						Er zijn nog geen verzendopties gevonden. We zijn druk bezig ze op te halen bij SendCloud. Probeer het
						later opnieuw.
					</div>

					<div v-else :key="shippingOption.id" v-for="(shippingOption) in this.shippingOptions"
						 class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/2">
						<vs-checkbox @change="updateShipping(shippingOption)" class="shippingOptions" v-model="shippingOption.enabled">
							{{ shippingOption.shipping_option.name }}
						</vs-checkbox>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);

const dict = {
	custom: {
		publicKey: {
			required: 'Vul hier je publieke sleutel in.',
			length: 'Vul 32 karakers in.',
		},
		privateKey: {
			required: 'Vul hier je geheime sleutel in.',
			length: 'Vul 32 karakers in.',
		},
	}
};
Validator.localize('en', dict);

export default {
	data() {
		return {
			loading: true,
			coupled: false,
			shippingOptions: [],
			submitCredentials: {
				public_key: null,
				private_key: null,
			},
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.$vs.loading();
			this.$store.dispatch('sendCloud/init').then(res => {
				this.credentials = this.$store.state.sendCloud.sendCloud.credentials;
				if (this.credentials) {
					this.coupled = true;
				}
				this.$vs.loading.close();
				this.loading = false;
				this.initShippingOptions();
			});
		},
		validateCreate() {
			this.$validator.validateAll().then(result => {
				if (!result) {
					this.$vs.notify({
						color: 'danger',
						title: 'Oops!',
						text: 'Vul alle velden in',
					});
				} else {
					this.createCredentials();
				}
			});
		},
		createCredentials() {
			this.$store.dispatch('sendCloud/createSendCloud', this.submitCredentials).then(res => {
				this.notifySuccessSendcloud();
				this.init();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		initShippingOptions() {
			if (this.coupled) {
				for (let i = 0; i < this.$store.state.sendCloud.sendCloud.shipping_options.length; i++) {
					this.shippingOptions[i] = {...this.$store.state.sendCloud.sendCloud.shipping_options[i]};
				}
			}
		},
		updateShipping(selected) {
			this.$store.dispatch('sendCloud/updateSippingOptions', selected).then(res => {
				this.notifySuccesUpdate();
			}).catch(err => {
				this.createNotifyFailed();
			});
		},
		notifySuccessSendcloud() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'Sendcloud is gekoppeld aan Piqwise!',
			});
		},
		notifySuccesUpdate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'Verzendoptie succesvol opgeslagen!',
			});
		},
		createNotifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Oops!',
				text: 'Er is iets fout gegaan.',
			});
		},
	}
}
</script>

<style scoped>
.btn-submit {
	width: 200px;
}

.shippingOptions {
	overflow-wrap: break-word;
}
</style>
